// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------

import $ from 'jquery';
import { formatMoney }        from '@shopify/theme-currency';
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';
import { handleClickIncrement, handleKeyDownIncrement } from 'snippets/form-kit/form-increment';

Shopify.AjaxifyCartPage = (function($){

    var _config = {
        itemQuantitySelector    : '.cart-specific-quantity',
        itemRemoveBtn           : '.cart__remove--ajax',
        shopifyAjaxCartURL      : window.localeUrl+'/cart.js',
        quantityInputDelayTime  : 500, // in miliseconds
        cartUndoMessageSelector : '.cart__undo-message',
        cartUndoButton          : '.cart__undo--ajax',
        checkoutButton          : '[name="checkout"]',
    };

    var _getInventory = function() {
        return $.ajax({
            type: "GET",
            url: window.localeUrl+'/cart?view=max-qty',
        })
    }

    var _refreshCartItemKeys = function(cartData) {
        for (let i = 0; i < cartData.items.length; i++) {
            $(`#updates_item_${i+1}`).attr('data-line-item-key', cartData.items[i].key);
            $(`#removes_item_${i+1}`).attr('data-line-item-key', cartData.items[i].key);
            $(`#removes_item_${i+1}`).attr('href', `/cart/change?id=${cartData.items[i].key}&quantity=0`);
        }
    }

    var _refreshCartItemPrice = function(cartData) {
        for (let i = 0; i < cartData.items.length; i++) {
            const hasDiscount = cartData.items[i].discounts.length > 0;
            const discountedPrice = formatMoney(cartData.items[i].discounted_price, theme.formatMoney);
            const originalPrice = formatMoney(cartData.items[i].original_price, theme.formatMoney);
            const lineTotalPrice = formatMoney(cartData.items[i].line_price, theme.formatMoney);
            const cartSubtotal = formatMoney(cartData.total_price, theme.formatMoney);

            if (hasDiscount) {
                $(`.cart-item__price:eq(${i})`).text(discountedPrice);
                $(`.cart-item__orig_price:eq(${i})`).html(`<s>${originalPrice}</s>`);
            } else {
                $(`.cart-item__price:eq(${i})`).text('');
                $(`.cart-item__orig_price:eq(${i})`).text(originalPrice);
            }

            $(`.cart__item--total-price:eq(${i})`).text(lineTotalPrice);
        }
    }

    var _refreshCartItemIds = function() {
        $('.cart-specific-quantity').each(function(i) {
            $(this).attr('id', `updates_item_${i+1}`);
        })
        $('.cart__remove').each(function(i) {
            $(this).attr('id', `removes_item_${i+1}`);
        })
    }

    var _removeLineItem = function(lineItemRemoveBtn) {
        // Get the line item info
        var $this                 = lineItemRemoveBtn,
        $selectedLineItemKey      = $this.data('line-item-key'),
        $selectedLineItemId       = $this.data('line-item-id'),
        $selectedLineItemTitle    = $this.data('line-item-title'),
        $selectedLineItemQuantity = $this.data('line-item-quantity'),
        $selectedLineItemSellingPlanId = $this.data('line-item-selling-plan-id'),
        $cartRow                  = $this.parents('.cart__row');

        // Remove the line item by updating its quantity to 0
        $.ajax({
            type: "POST",
            url: window.localeUrl+'/cart/change.js',
            data: { quantity: 0, id: $selectedLineItemKey },
            dataType: 'json',
            success: function(cartData) {

                if ( $this.data('undo') == false ) { // If removing an out of stock product - refresh the page
                    location.reload();
                }else{
                    $('.cart__item--total-wrapper .product__price').each(function(){
                        $(this).addClass('loading');
                    });
                    $('.cart-info__subtotal').addClass('loading');
                    $('.cart__total-price').addClass('loading');
                    $('.cart-price--discount').addClass('loading');
                    $('.cart-price--shipping').addClass('loading');

                    // Update free shipping progress
                    Shopify.freeShippingProgress.init();
                    // Remove line item row
                    $cartRow.remove();
                    _refreshCartItemIds();

                    $.ajax({
                        url: _config.shopifyAjaxCartURL,
                        cache: false,
                        dataType: "json",
                        success: function(cartData) {

                            _refreshCartItemKeys(cartData);
                            _refreshCartItemPrice(cartData);
                            cartSubtotalUpdate(cartData);

                            // Generate Undo message
                            var $message = "";

                            $message += "<p>";
                                $message += $selectedLineItemTitle + ' ' + window.translations.cartProductRemovedMessage ;
                                $message += "<a href='' class='cart__undo cart__undo--ajax' data-line-item-id='"+$selectedLineItemId+"' data-line-item-selling-plan-id='"+$selectedLineItemSellingPlanId+"' data-line-item-quantity='"+$selectedLineItemQuantity+"' >";
                                    $message += ' ' + window.translations.cartUndoLabel;
                                $message += "?</a>";
                            $message += "</p>";

                            if ($(_config.cartUndoMessageSelector).is(':empty')){
                                $(_config.cartUndoMessageSelector).empty().html($message);
                            }else{

                                $(_config.cartUndoMessageSelector).fadeOut(200, function(){
                                    $(_config.cartUndoMessageSelector).empty().html($message);
                                    $(_config.cartUndoMessageSelector).fadeIn(200);
                                });
                            }

                            $('.cart__item--total-wrapper .product__price').each(function(){
                                $(this).removeClass('loading');
                            });
                            $('.cart-info__subtotal').removeClass('loading');
                            $('.cart__total-price').removeClass('loading');
                            $('.cart-price--discount').removeClass('loading');
                            $('.cart-price--shipping').removeClass('loading');
                        }
                    });

                    setTimeout(function () {
                        $('.cart__item--total-wrapper .product__price').each(function(){
                            $(this).removeClass('loading');
                        });
                        $('.cart-info__subtotal').removeClass('loading');
                        $('.cart__total-price').removeClass('loading');
                        $('.cart-price--discount').removeClass('loading');
                        $('.cart-price--shipping').removeClass('loading');
                    }, 1000);
                }

            },
            error: function(XMLHttpRequest, textStatus, error) {
                console.error(error);
            }
        });
    }

    var _init = function () {

        $(document).ready(function(){

            $("body").on('click', _config.cartUndoButton, function(e){
                e.preventDefault();

                // Get the line item id
                var $selectedLineItemId       = $(this).data('line-item-id'),
                    $selectedLineItemQuantity = $(this).data('line-item-quantity'),
                    $selectedLineItemSellingPlanId = $(this).data('line-item-selling-plan-id');

                $.ajax({
                    type: "POST",
                    url: window.localeUrl+'/cart/add.js',
                    data: { items: [ {quantity: $selectedLineItemQuantity, id: $selectedLineItemId, selling_plan: $selectedLineItemSellingPlanId} ] },
                    dataType: 'json',
                    success: function(data) {

                        location.reload();

                    },
                    error: function(XMLHttpRequest, textStatus, error) {

                        var $response = XMLHttpRequest.responseJSON;
                        var $message = "<p>"+$response.description+"</p>";

                        $(_config.cartUndoMessageSelector).replaceWith($message);
                    }
                });
            })

            $("body").on('click', _config.itemRemoveBtn, function(e){
                e.preventDefault();

                _removeLineItem($(this));
            });

            $("body").on('change', _config.itemQuantitySelector, function () {

                var $this      = $(this),
                    $cartRow   = $this.parents('.cart__row'),
                    $inventory = _getInventory(),
                    $thisInputId = $(this).attr('id'),
                    $thisInputIndex = $thisInputId.substring(13); // Trim index number from id

                // If user input 0 quantity, remove the item from the cart
                if($this.val() == 0) {
                    const lineItemRemoveBtn = $this.parents(".cart__line-item").find(_config.itemRemoveBtn)
                    _removeLineItem(lineItemRemoveBtn);
                } else {
                    // If user input negative quantities, force input value to 1
                    if($this.val() < 0) {
                        $this.val(1);
                        $cartRow.find('.cart__item--quantity__message').empty();
                    } else if($this.val() > 9) {
                        $this.val(9);
                        $cartRow.find('.cart__item--quantity__message').empty().append(`<p>${window.translations.maxQuantityMessage}</p>`);
                    } else {
                        $cartRow.find('.cart__item--quantity__message').empty();
                    }

                    setTimeout(function(){

                        $.when(_getInventory()).done(function(data) {

                            var $inventory                          = $.parseJSON(data),
                                $selectedLineItemKey                = $this.attr('data-line-item-key'),
                                $selectedLineItemId                 = $this.attr('data-line-item-id'),
                                $selectedProductHandle              = $this.attr('data-handle'),
                                $selectedLineItemPrice              = parseInt($this.attr('data-price')),
                                $selectedLineItemInventoryPolicy = $this.attr('data-inventory-policy'),
                                $selectedLineItemInventoryManagement = $this.attr('data-inventory-management'),
                                $selectedLineItemTotalPriceSelector = $this.parents('.cart__item--quantity').siblings('.cart__item--total');

                            $.each($inventory, function(key, value){


                                if ( key == $selectedLineItemId) {

                                    var $availableQty = parseInt(value);
                                    if ( $availableQty <= 0 && $selectedLineItemInventoryPolicy != 'continue' && $selectedLineItemInventoryManagement != 'none' ) { // If out of stock
                                        var $selectedQuantity = $this.val();
                                        $(_config.checkoutButton).prop('disabled', true);
                                        $cartRow.find('.cart__item--message').empty().append("<p>This item is no longer available. Please <a data-undo='false' href='' data-line-item-id='"+$selectedLineItemId+"' data-line-item-key='"+$selectedLineItemKey+"' class='cart__remove cart__remove--ajax'>remove this item</a> before continuing to checkout.</p>");
                                    }else{

                                        if ( $availableQty < parseInt($this.val()) && $selectedLineItemInventoryPolicy != 'continue' && $selectedLineItemInventoryManagement != 'none') { // If available stock is less than line item qty
                                            $this.val($availableQty);
                                            var $selectedQuantity = $availableQty;
                                        }else{
                                            var $selectedQuantity = $this.val();
                                        }
                                    }

                                    // Update data-line-item-quantity attribute for the remove button
                                    $cartRow.find(_config.itemRemoveBtn).data('line-item-quantity', $selectedQuantity);
                                    var $selectedLineItemTotalPrice = formatMoney($selectedQuantity*$selectedLineItemPrice, theme.moneyFormat);


                                    $.ajax({
                                        type: "POST",
                                        url: window.localeUrl+'/cart/change.js',
                                        data: { quantity: $selectedQuantity, id: $selectedLineItemKey },
                                        dataType: 'json',
                                        async: false,
                                        success: function(cartData) {

                                            $('.cart__item--total-wrapper .product__price').each(function(){
                                                $(this).addClass('loading');
                                            });
                                            $('.cart-info__subtotal').addClass('loading');
                                            $('.cart__total-price').addClass('loading');
                                            $('.cart-price--discount').addClass('loading');
                                            $('.cart-price--shipping').addClass('loading');

                                            // Update free shipping progress
                                            Shopify.freeShippingProgress.init();

                                            $.ajax({
                                                url: _config.shopifyAjaxCartURL,
                                                cache: false,
                                                dataType: "json",
                                                async: false,
                                                success: function(cartData) {
                                                    _refreshCartItemKeys(cartData);
                                                    _refreshCartItemPrice(cartData);
                                                    cartSubtotalUpdate(cartData);

                                                    setTimeout(function () {
                                                        $('.cart__item--total-wrapper .product__price').each(function(){
                                                            $(this).removeClass('loading');
                                                        });
                                                        $('.cart-info__subtotal').removeClass('loading');
                                                        $('.cart__total-price').removeClass('loading');
                                                        $('.cart-price--discount').removeClass('loading');
                                                        $('.cart-price--shipping').removeClass('loading');
                                                    }, _config.quantityInputDelayTime);
                                                }
                                            });

                                        },
                                        error: function(XMLHttpRequest, textStatus, error) {
                                            console.error(error);
                                        }
                                    });
                                }
                            });
                        });

                    },_config.quantityInputDelayTime);
                }
            })
        })
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)

$(document).ready(function(){
    Shopify.AjaxifyCartPage.init();
})
